import type { HatView, PersonCard } from "../types";

/** The formal firm against the actual firm, as discovered so far (19 §4.5). No totals, no counts of unknowns. */
export function HatsPanel({ hats, people }: { hats: HatView[]; people: PersonCard[] }) {
  const nameOf = (id: string) => people.find((p) => p.id === id)?.name ?? "Someone who has left";
  const domains = [...new Set(hats.map((h) => h.domain))];
  return (
    <section className="panel" aria-labelledby="hats-title">
      <h2 id="hats-title" className="panel-title">Hats</h2>
      <table className="hats-table">
        <caption className="visually-hidden">Hats by area: who formally owns each, and who actually does it as far as you know</caption>
        <thead>
          <tr><th scope="col">Hat</th><th scope="col">Formal owner</th><th scope="col">Actually done by (as you know it)</th></tr>
        </thead>
        {domains.map((d) => (
          <tbody key={d}>
            <tr className="hats-table__domain"><th scope="rowgroup" colSpan={3}>{d.charAt(0).toUpperCase() + d.slice(1)}</th></tr>
            {hats.filter((h) => h.domain === d).map((h) => {
              const formal = h.formalOwnerId ? nameOf(h.formalOwnerId) : null;
              const ids = h.actualOwnerIds;
              const actual = ids ? ids.map(nameOf) : null;
              const differs = ids !== null && h.formalOwnerId !== null && ids.length > 0 && !(ids.length === 1 && ids[0] === h.formalOwnerId);
              return (
                <tr key={h.id}>
                  <th scope="row">{h.name}</th>
                  <td>{formal ?? <span className="muted">no formal owner</span>}</td>
                  <td>
                    {actual === null ? <span className="muted">? not yet looked into</span>
                      : actual.length > 0 ? actual.join(", ") : <span className="muted">nobody</span>}
                    {differs && <span className="mismatch"> <span aria-hidden="true">≠</span> formal and actual differ</span>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        ))}
      </table>
      <div className="unmapped">
        <h3>Unmapped</h3>
        <p>Work happens here that you haven't traced yet.</p>
      </div>
    </section>
  );
}
